import React from "react";
import { Box, Text, Flex, Image, Icon, Menu, MenuButton, MenuList, MenuItem, MenuGroup, MenuDivider } from "@chakra-ui/react";
import { HiOutlineFunnel } from "react-icons/hi2";
import { c } from "../classroomColors";

const StudentAssignedWorkTile = ({ iconSrc, label, content, filterGroups = [] }) => {
  return (
    <Box
      width="100%"
      flexShrink={0}
      alignSelf="stretch"
      borderRadius="12px"
      background={c.surface}
      border="1px solid"
      borderColor={c.inputBorder}
      padding="24px"
      display="flex"
      flexDirection="column"
      gap="20px"
      boxShadow="sm"
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="center" gap="10px">
          {iconSrc && <Image src={iconSrc} boxSize="24px" />}
          <Text fontSize="20px" fontWeight="500" color={c.text}>
            {label}
          </Text>
        </Flex>

        {filterGroups.length > 0 && (
          <Menu autoSelect={false} closeOnSelect={true}>
            <MenuButton
              as={Box}
              cursor="pointer"
              padding="8px"
              borderRadius="8px"
              _hover={{ background: c.hover }}
              transition="background 0.2s"
              display="flex"
              alignItems="center"
              justifyContent="center"
              border="1px solid"
              borderColor={c.inputBorder}
            >
              <Icon as={HiOutlineFunnel} boxSize="18px" color={c.textSub} />
            </MenuButton>
            <MenuList
              minWidth="220px"
              borderRadius="12px"
              bg={c.surface}
              border="1px solid"
              borderColor={c.inputBorder}
              boxShadow="0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)"
              padding="8px"
              zIndex="10"
              maxHeight="400px"
              overflowY="auto"
            >
              {filterGroups.map((group, gIdx) => (
                <React.Fragment key={gIdx}>
                  <MenuGroup
                    title={group.title}
                    fontSize="11px"
                    fontWeight="700"
                    color={c.textMuted}
                    textTransform="uppercase"
                    ml="12px"
                    mt="8px"
                    mb="4px"
                  >
                    {group.options.map((opt, oIdx) => (
                      <MenuItem
                        key={oIdx}
                        onClick={opt.onClick}
                        borderRadius="8px"
                        fontSize="13px"
                        fontWeight={opt.isActive ? "600" : "400"}
                        color={opt.isActive ? c.accentSoftText : c.text}
                        background={opt.isActive ? c.accentSoft : "transparent"}
                        _hover={{ background: opt.isActive ? c.accentSoft : c.hover }}
                        _focus={{ background: opt.isActive ? c.accentSoft : c.hover }}
                        padding="8px 12px"
                      >
                        <Flex justify="space-between" width="100%" align="center">
                          <Text>{opt.label}</Text>
                          {opt.isActive && <Box w="6px" h="6px" borderRadius="full" bg={c.accent} />}
                        </Flex>
                      </MenuItem>
                    ))}
                  </MenuGroup>
                  {gIdx < filterGroups.length - 1 && <MenuDivider mx="8px" my="8px" />}
                </React.Fragment>
              ))}
            </MenuList>
          </Menu>
        )}
      </Flex>

      <Box
        flex="1"
        overflowY="auto"
        maxHeight="600px"
        pr="4px"
      >
        {typeof content === "string" ? (
          <Flex alignItems="center" justifyContent="center" height="150px" bg={c.surfaceSubtle} borderRadius="8px">
            <Text
              fontSize="14px"
              fontWeight="300"
              color={c.textSub}
              textAlign="center"
            >
              {content}
            </Text>
          </Flex>
        ) : (
          <Flex direction="column" gap="12px">
            {content}
          </Flex>
        )}
      </Box>
    </Box>
  );
};

export default StudentAssignedWorkTile;
